module.exports = __webpack_public_path__ + "img/csm__MG_9100-1_ce932a9532.ca27ba2b.jpg";